import React from 'react';
import { useSearchParams, Link as RouterLink } from 'react-router-dom';
import { Container, Box, Typography, Button, Alert } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { glass, brand } from './theme';

const OUTCOME = {
    paid: { severity: 'success', icon: CheckCircleIcon, title: 'پرداخت با موفقیت انجام شد', text: 'همکاری آغاز شد — مشخصات تماس طرف مقابل در صفحه‌ی قرارداد در دسترس است.' },
    failed: { severity: 'error', icon: ErrorOutlineIcon, title: 'پرداخت ناموفق بود', text: 'مبلغی از حساب شما کسر نشد. لطفاً دوباره تلاش کنید.' },
    canceled: { severity: 'warning', icon: CancelIcon, title: 'پرداخت لغو شد', text: 'شما از درگاه پرداخت خارج شدید. می‌توانید هر زمان دوباره اقدام کنید.' },
};

function PaymentResult() {
    const [params] = useSearchParams();
    const status = params.get('status') || 'failed';
    const requestId = params.get('request_id');
    const outcome = OUTCOME[status] || OUTCOME.failed;
    const Icon = outcome.icon;

    return (
        <Box sx={{ background: glass.canvasGradient, minHeight: '100%', py: 6 }}>
            <Container maxWidth="sm">
                <Box sx={{ ...glass.card, p: { xs: 3, md: 5 }, textAlign: 'center' }}>
                    <Icon sx={{
                        fontSize: 56, mb: 1.5,
                        color: outcome.severity === 'success' ? brand.primary : outcome.severity === 'warning' ? brand.accentDeep : 'error.main',
                    }} />
                    <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>{outcome.title}</Typography>
                    <Alert severity={outcome.severity} sx={{ borderRadius: '12px', textAlign: 'right', mb: 3 }}>
                        {outcome.text}
                    </Alert>
                    {requestId ? (
                        <Button component={RouterLink} to={`/contracts/${requestId}`} variant="contained" size="large" fullWidth>
                            بازگشت به قرارداد
                        </Button>
                    ) : (
                        <Button component={RouterLink} to="/dashboard" variant="contained" size="large" fullWidth>
                            بازگشت به داشبورد
                        </Button>
                    )}
                </Box>
            </Container>
        </Box>
    );
}

export default PaymentResult;
